import React from 'react';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import store from "../../../redux/store";

/**
 *
 * @param {*} param0
 */
const NavigationItem = ({ label, isActive, isSeen, onClick, customStyle }) => {
    const styles = {
        blueBlock: {
            borderBottom: `4px solid ${ store.getState().whitelabel.primaryColor || Theme.colors.skyBlue }`
        },
        greyBlock: {
            borderBottom: `4px solid ${ Theme.colors.lightGrey }`
    
        }
    };
    
    return (
        <div
            style={ isSeen ? { cursor: 'pointer', ...customStyle, ...styles.blueBlock } : { cursor: 'default', ...customStyle, ...styles.greyBlock } }
            onClick={ onClick }
        >
            <Text
                tiny
                bold
                display="block"
                align="center"
                customStyle={{ paddingBottom: 20, marginTop: 10, paddingTop: 10 }}
                color={ isActive ? Theme.colors.darkGrey : Theme.colors.mediumLightGrey }
            >
                { label }
            </Text>
        </div>
    );
};

export default (NavigationItem);